import { render, staticRenderFns } from "./custom-rate.vue?vue&type=template&id=b4bba30c&scoped=true&"
import script from "./custom-rate.vue?vue&type=script&lang=js&"
export * from "./custom-rate.vue?vue&type=script&lang=js&"
import style0 from "./custom-rate.vue?vue&type=style&index=0&id=b4bba30c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4bba30c",
  null
  
)

export default component.exports